/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibRichErrorsV061,
  LibRichErrorsV061Interface,
} from "../LibRichErrorsV061";

const _abi = [
  {
    inputs: [],
    name: "STANDARD_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "StandardError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "rrevert",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibRichErrorsV061__factory {
  static readonly abi = _abi;
  static createInterface(): LibRichErrorsV061Interface {
    return new utils.Interface(_abi) as LibRichErrorsV061Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibRichErrorsV061 {
    return new Contract(address, _abi, signerOrProvider) as LibRichErrorsV061;
  }
}
